import React from "react";
import { useLocation } from "react-router-dom";
import NodePage from "./NodePage";

const NodePageWrapper = (props) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const uuid = params.get("uuid");

  return <NodePage {...props} uuid={uuid} />;
};

export default NodePageWrapper;
